export const number = "0123456789";
export const upperCaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const lowerCaseLetters = "abcdefghijklmnopqrstuvwxyz";
export const specialCharacters = "!'^+%&/()=?_#$½§{[]}|;:>÷`<.*-@é";
